import RedebitPaymentStatusModelBase from '../_generated/modelBases/redebit-payment-status-model-base';

export default class RedebitPaymentStatusModel extends RedebitPaymentStatusModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
